import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { pushPage } from '../components/back-button/back-button-slice';
import { setNavigatingBackToSearch } from '../features/search/search-slice';

interface LocationState {
    navigatedBack?: boolean;
    fromSearch?: boolean;
}

const BackButtonNavigationTracking = (
    pageName: string,
    WrappedComponent: React.ComponentType<any>
) =>
    function (props: any) {
        const location = useLocation();
        const dispatch = useDispatch();

        // Push the current page to the navigation stack
        useEffect(() => {
            dispatch(pushPage({ path: location.pathname, name: pageName }));
        }, [location.pathname, dispatch, pageName]);

        useEffect(() => {
            if (pageName === 'Search') {
                const state = location.state as LocationState | undefined;
                const hasNavigatedBack =
                    !!state &&
                    (state.navigatedBack === true || state.fromSearch === true);

                if (hasNavigatedBack) {
                    dispatch(setNavigatingBackToSearch(true));
                    window.history.replaceState({}, document.title);
                } else {
                    dispatch(setNavigatingBackToSearch(false));
                }
            }
        }, [pageName, location.key, location.state, dispatch]);

        return React.createElement(WrappedComponent, { ...props });
    };
export default BackButtonNavigationTracking;
